import { Aurelia, PLATFORM, autoinject, BindingEngine, LogManager } from 'aurelia-framework';
import { Router, RouterConfiguration, NavigationInstruction, Next } from 'aurelia-router';
import { Routes } from './_routes';
import { Lookups } from '@data/lookups';
import { IdentityHelpers } from '@identity/helpers';
import { IApiResponse, IEntityPerson } from '@shared/interfaces/interfaces';
import { EventAggregator } from 'aurelia-event-aggregator';
declare let gtag: Function;

@autoinject
export class App {

  private logger: any = LogManager.getLogger('app');
  public title = 'The Curious Piano Teachers Blog';
  private lookups: Lookups;
  private router!: Router;
  private identity!: IdentityHelpers;
  private routerReady: boolean = false;
  private bind: BindingEngine;
  private routeBuilder: Routes;
  private subscription: any;
  private lookupsError: boolean = false;
  private spaName: string = 'blog';
  private navEvent: any;
  private ea: EventAggregator;

  constructor(
    lookups: Lookups, bindingEngine: BindingEngine, routes: Routes,
    identity: IdentityHelpers, ea: EventAggregator) {
    this.lookups = lookups;
    this.bind = bindingEngine;
    this.routeBuilder = routes;
    this.identity = identity;
    this.ea = ea;
  }

  configureRouter(config: RouterConfiguration, router: Router) {

    config.options.pushState = true;
    // config.title = 'The Curious Piano Teachers Blog';
    config.addAuthorizeStep(AuthorizeStep);
    config.map(this.routeBuilder.routeArray);
    config.mapUnknownRoutes((instruction: NavigationInstruction) => {
      const route = instruction.fragment === '/blog'
        || instruction.fragment === '/blog/' ?
        this.routeBuilder.routeArray[0] : this.routeBuilder.unknownRoute;
      return route;
    });
    this.router = router;

    this.subscription = this.bind.collectionObserver(this.router.routes)
      .subscribe(this.routerConfigured.bind(this));
  }

  routerConfigured(splices: any) {
    this.routerReady = true;
    this.subscription.dispose();

    this.navEvent = this.ea.subscribe(
      'router:navigation:complete',
      (response: any) => {
        console.log(response);
        console.log(window.location);
        console.log(document.title);

        // only submit to analytics if cookie consent allows it!
        // TODO - test event correctly sent to Analytics if cookie consent
        // and not sent if no consent
        // also test consent given subsequent to initial page load!
        const consentCookie = this.getCookie('cpt-cookie-consent');

        if (!consentCookie || consentCookie.indexOf('-analytics') === -1) {
          return;
        }

        if (typeof (gtag) !== 'undefined') {
          gtag('js', new Date());
          gtag('config', 'G-PMPJFNGGSE');
          // gtag('event', 'page_view', {
            // page_title: document.title,
            // page_location: window.location.pathname,
            //// page_path: window.location.pathname,
          // });
        }

      });
    // console.log(response.instruction.fragment);
  }

  getCookie(name: String) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
  }

  async getUserInfo(): Promise<IApiResponse> {

    const promise: any = new Promise(async (resolve, reject) => {

      const response = await this.identity.getUserInfoAsync();
      return resolve(response);

    });

    return promise;

  }

  attached() {
  }

  async getPerson(): Promise<breeze.Entity[]> {

    this.lookupsError = false;
    const personResponse: any = await this.lookups.getPerson(this.identity.user.PersonId, false, 'blog.app.app')
      .catch((err) => {
        console.log(err);
        this.lookupsError = true;
      });

    return personResponse;

  }

  async activate(): Promise<void> {

    const promise: any = new Promise<void>(async (resolve, reject) => {

      await this.identity.initialiseIdentityAsync();
      console.log('Got identity');

      const gotUser = await this.getUserInfo();
      console.log(`Got user? ${gotUser}`);

      // if (gotUser.statusCode !== 200) {
      //  this.lookupsError = true;
      //  return resolve();
      // }

      if (this.identity.user.IsAuthenticated) {

        // const personResponse: any =
        // await this.lookups.getPerson(this.identity.user.PersonId, false, 'blog.app.app')
        //  .catch((err) => {
        //    // TODO - Handle Error! App can't function without person
        //    // try again(refresh) option ? handle lost internet connection?
        //    console.log(err);
        //    // this.lookupsError = true;
        //  });

        let personResponse: any = await this.getPerson();

        if (this.lookupsError) {
          setTimeout(
            async () => {
              personResponse = await this.getPerson();
            },
            200);
        }

        if (this.lookupsError) {
          // return resolve();
        }

        this.lookupsError = false;

        const personData: breeze.Entity[] = <breeze.Entity[]>personResponse;
        if (!personData || personData.length === 0) {
          console.log('No person data found');
          // this.lookupsError = true;
          // return resolve();
        }

        if (personData && personData.length > 0) {
          console.log('Got person');
          this.identity.user.Person = <IEntityPerson>personData[0];
        }

      }

      const lookups = await this.lookups.getData('Blog', 'blog.app.app')
        .catch((err) => {
          // TODO - Handle Error! App can't function without lookups
          // try again(refresh) option ? handle lost internet connection?
          console.log(err);
          this.lookupsError = true;
        });

      if (this.lookupsError) {
        return resolve();
      }

      console.log('Got lookups');
      console.log(lookups);
      // const gotUser = await this.getUserInfo();
      // console.log(`Got user? ${gotUser}`);
      // this.identity.test();
      // var mgr = getEntityManager();
      // console.log(mgr.getEntities('Event'));
      // self.logger.debug(mgr.getEntities('Event'));

      return resolve();

    });

    return promise;

  }
}

@autoinject
class AuthorizeStep {

  private identity: IdentityHelpers;
  private router: Router;

  constructor(identity: IdentityHelpers, router: Router) {
    this.identity = identity;
    this.router = router;
  }

  run(navigationInstruction: NavigationInstruction, next: Next): Promise<any> {

    if (navigationInstruction.getAllInstructions().some(i => i.config.settings.authorize)) {

      if (!this.identity.user.IsAuthenticated ||
        !this.identity.isUserInRole(navigationInstruction.config.settings.authorize)) {
        return next.cancel(this.router.navigateToRoute(
          'login',
          { page: navigationInstruction.fragment }, { replace: true }));
      }

    }

    return next();
  }

}
